export default __webpack_public_path__ + "static/media/background.efdc0c8e.jpg";